webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIZE_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SPACE_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VALIGN_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALIGN_VALUES; });
var SIZE_VALUES = ['flush', 'tiny', 'small', 'large', 'huge'];

var SPACE_VALUES = ['around', 'between', 'center', 'end'];

var VALIGN_VALUES = ['middle', 'bottom'];

var ALIGN_VALUES = ['left', 'right'];

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Media__ = __webpack_require__(19);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Media", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Media__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Grid__ = __webpack_require__(17);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_1__components_Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GridItem__ = __webpack_require__(18);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GridItem", function() { return __WEBPACK_IMPORTED_MODULE_2__components_GridItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Block__ = __webpack_require__(16);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Block", function() { return __WEBPACK_IMPORTED_MODULE_3__components_Block__["a"]; });





/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Block__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Block__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Block___default.a);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Grid__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Grid___default.a);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GridItem__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GridItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__GridItem__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__GridItem___default.a);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Media__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Media___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Media__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Media___default.a);

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constraints__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Block',
  props: {
    src: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].string.isRequired,
    alt: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].string.isRequired,
    size: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].oneOf(__WEBPACK_IMPORTED_MODULE_2__constraints__["a" /* SIZE_VALUES */]),
    align: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].oneOf(__WEBPACK_IMPORTED_MODULE_2__constraints__["b" /* ALIGN_VALUES */])
  },
  data: function data() {
    return {};
  },

  computed: {
    classes: function classes() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'o-block--' + this.align, this.align), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'o-block--' + this.size, this.size), _ref;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constraints__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Grid',
  props: {
    valign: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].oneOf(__WEBPACK_IMPORTED_MODULE_2__constraints__["c" /* VALIGN_VALUES */]),
    size: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].oneOf(__WEBPACK_IMPORTED_MODULE_2__constraints__["a" /* SIZE_VALUES */]),
    space: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].oneOf(__WEBPACK_IMPORTED_MODULE_2__constraints__["d" /* SPACE_VALUES */]),
    stretch: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].bool.def(false),
    auto: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].bool.def(false),
    liquid: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].bool.def(false),
    reverse: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].bool.def(false),
    wrapped: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].bool.def(false)
  },
  data: function data() {
    return {};
  },

  computed: {
    classes: function classes() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'o-grid--' + this.valign, this.valign), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'o-grid--' + this.size, this.size), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'o-grid--' + this.space, this.space), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'o-grid--stretch', this.stretch), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'o-grid--wrapped', this.wrapped), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'o-grid--liquid', this.liquid), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'o-grid--auto o-grid--liquid', this.auto), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'o-grid--reverse', this.reverse), _ref;
    }
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Grid-item',
  props: {
    width: {
      type: String,
      validator: function validator(value) {
        var split = value.split('/');
        return value.match(/^[1-9]\/[1-9]$/g) && split[0] <= split[1];
      }
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    computedStyle: function computedStyle() {
      if (!this.width) return null;

      return { width: this.getWidthFromFraction(this.width) };
    }
  },
  methods: {
    getWidthFromFraction: function getWidthFromFraction(fraction) {
      var split = fraction.split('/');
      var result = parseInt(split[0]) / parseInt(split[1]);

      return this.round(result, 5) * 100 + '%';
    },
    round: function round(value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constraints__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Media',
  props: {
    src: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].string.isRequired,
    alt: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].string.isRequired,
    size: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].oneOf(__WEBPACK_IMPORTED_MODULE_2__constraints__["a" /* SIZE_VALUES */]),
    valign: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].oneOf(__WEBPACK_IMPORTED_MODULE_2__constraints__["c" /* VALIGN_VALUES */]),
    stretch: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].bool.def(false),
    reverse: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].bool.def(false)
  },
  data: function data() {
    return {};
  },

  computed: {
    classes: function classes() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'o-media--' + this.valign, this.valign), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'o-media--' + this.size, this.size), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'o-media--stretch', this.stretch), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'o-media--reverse', this.reverse), _ref;
    }
  }
});

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(61),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(58),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-grid__item",
    style: (_vm.computedStyle)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-media",
    class: [_vm.classes]
  }, [_c('div', {
    staticClass: "o-media__img"
  }, [_c('img', _vm._b({}, 'img', {
    src: _vm.src,
    alt: _vm.alt
  }, false))]), _vm._v(" "), _c('div', {
    staticClass: "o-media__body"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-block",
    class: [_vm.classes]
  }, [_c('div', {
    staticClass: "o-block__img"
  }, [_c('img', _vm._b({}, 'img', {
    src: _vm.src,
    alt: _vm.alt
  }, false))]), _vm._v(" "), _c('div', {
    staticClass: "o-block__body"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 62 */,
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-grid",
    class: [_vm.classes]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ })
],[7]);


// WEBPACK FOOTER //
// docs/js/vue-objects.fd20178cf68ed8dfdf3f.js